export const CHECKOUT_URL = "https://piano-master-fr.impultienda.ar/checkout";

export const testimonials = [
  {
    name: "Camille Laurent & Sophie Martin",
    role: "Professeures de piano, école de musique à Lyon",
    quote:
      "Nous utilisons le pack dans toute notre école. Le guide théorique nous a enfin donné une progression commune, et le bonus « Mon Premier Petit Récital » nous a permis d'organiser notre audition de fin d'année sans stress. Les parents étaient ravis.",
    image: "https://cdn.magicpatterns.com/uploads/kU5u2tFAQLcymk9boSnaFC/image3.jpg",
  },
  {
    name: "Julien Moreau",
    role: "Professeur particulier à Bordeaux",
    quote:
      "Je gagne au moins trois heures de préparation par semaine. J'imprime les fiches, je les distribue et mes élèves savent exactement quoi travailler.",
    image: "https://cdn.magicpatterns.com/uploads/qZz7MB7Cfa2M9ZS16ZJssV/images_1.jpg",
  },
  {
    name: "Élodie Rousseau",
    role: "Professeure, avec son élève Thomas",
    quote:
      "Thomas travaille enfin à la maison grâce au kit de pratique. En deux mois, sa lecture a fait un bond incroyable.",
    image: "https://cdn.magicpatterns.com/uploads/oGDwLg7Pc17nBzE94yh8R1/images_4.jpg",
  },
  {
    name: "Marc-Antoine Diallo",
    role: "Pianiste et professeur à Paris",
    quote:
      "La boîte à jeux a changé mes cours avec les enfants. Ils arrivent en courant et ne veulent plus partir !",
    image: "https://cdn.magicpatterns.com/uploads/nxo4AHCeMBVTU6eCdyN2vG/images.jpg",
  },
];
